/*
 * @Author: bbqin
 * @Date: 2023-01-04 10:31:03
 * @LastEditTime: 2023-01-04 16:43:46
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\api\cryptograph\asymmetric.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import AES from './adapter/common';
import SM from './adapter/sm';

/**
 * 加密解密器
 */
class Asymmetric {
    constructor(props) {
        // common sm
        this.algorithmName = props.algorithmName || 'common';

        // 算法
        this.algorithm = this.getAlgorithm(props.config);
    }

    /**
     * 获取当前的算法
     * @param {object} config 
     * @returns  {object | null}
     */
    getAlgorithm(config = {}) {
        let algorithm = null;
        // TODO  根据算法类型  获得对应算法方案
        switch (this.algorithmName) {
            case 'common':
                algorithm = new AES(config);
                break;
            case 'sm':
                algorithm = new SM(config);
                break;
            default:
                algorithm = new AES(config);
                break;
        }
        // 应该不存在  不生成密钥的方式
        return algorithm;
    }

    /**
     * 非对称加密
     * @param {string} message 
     * @param {string} key 
     * @returns {string}
     */
    asymmetricEncrypt(message, key) {

        return this.algorithm?.asymmetricEncrypt(message, key);
    }

    /**
     * 非对称解密
     * @param {string} message 
     * @param {string} key 
     * @returns {string}
     */
    asymmetricDecrypt(message, key) {

        return this.algorithm?.asymmetricDecrypt(message);
    }

    /**
     * 生成公钥
     * @returns {string}
     */
    generatePublicKey() {
        return this.algorithm?.generatePublicKey();
    }

    /**
     * 获取公钥
     * @returns {string}
     */
    getPublicKey(params = {}) {
        let pubkey = '';
        switch (this.algorithmName) {
            case 'common':
                pubkey = this.algorithm?.getPublicKey(params.exponent, params.modulus);
                break;
            case 'sm':
                pubkey = params;
                break;
            default:
                pubkey = this.algorithm?.getPublicKey(params.exponent, params.modulus);
                break;
        }
        return pubkey;
    }
}

export default Asymmetric;